<template>
  <section class="layout-container">
    <div class="row form-container">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 left-side">
        <h3 class="title">
          <app-i18n code="common.congratulations"></app-i18n>
        </h3>
        <h5 class="message">
          <app-i18n code="auth.verifiedEmailMessage"></app-i18n>
          <!-- <app-i18n :code="email"></app-i18n> -->
        </h5>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 right-side">
        <q-img src="/images/auth/verified-email.webp"></q-img>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/auth';

import { UserModel } from '@/modules/auth/user-model';
const { fields } = UserModel;

export default {
  name: 'app-verified-email-page',
  props: {
    actionCode: {
      type: String,
      required: true,
    },
    continueUrl: {
      type: String,
      required: false,
    },
    lang: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      email: undefined,
      isPwd: true,
      newPassword: undefined,
      isConfirmPwd: true,
      confirmPassword: undefined,
      model: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      // loading: 'auth/loadingPasswordResetEmail',
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
      menuCollapsed: 'layout/menuCollapsed',
      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
    }),

    fields() {
      return fields;
    },
    isRTL() {
      // return localStorage.getItem('language') == 'ar'
      return this.currentLanguageCode == 'ar';
    },
  },

  // async mounted() {
  //   // Verify the password reset code is valid.
  //   let accountEmail = ''
  //   accountEmail = await firebase.auth().verifyPasswordResetCode(this.actionCode)
  //   // .then((email) => {
  //   //   this.accountEmail = email;
  //   //   console.log('accountEmail = ', accountEmail);
  //   // })
  //   // .catch((error) => {
  //   //     console.log(error);
  //   //     // Invalid or expired action code. Ask user to try to reset the password again.
  //   // });
  //   console.log('accountEmail = ', accountEmail);
  //   this.email = accountEmail
  // },
  methods: {
    ...mapActions({
      // doSendPasswordResetEmail: 'auth/doSendPasswordResetEmail',
    }),
    i18n(key, args) {
      return this.$t(key, args);
    },
    async handleVerifyEmail() {
      debugger
      try {
        // Try to apply the email verification code.
        this.loading = true
        const resp = await firebase.auth().applyActionCode(this.actionCode)
        console.log(resp);

        // Email address has been verified.

        // TODO: Display a confirmation message to the user.
        // You could also provide the user with a link back to the app.

        // TODO: If a continue URL is available, display a button which on
        // click redirects the user back to the app via continueUrl with
        // additional state determined from that URL's parameters.

      } catch (error) {
        console.log(error);
        // Code is invalid or expired. Ask the user to verify their email address again.
      }

      this.loading = false
    },
    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      await this.doSendPasswordResetEmail(this.model.email);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  padding-top: 150px !important;
  padding-bottom: 90px !important;
}

.left-side {
  padding-left: 0 !important;
  padding-right: 65px !important;

  .title {
    font-style: normal !important;
    font-weight: bold !important;
    font-size: 50px !important;
    line-height: 75px !important;
    display: flex !important;
    align-items: center !important;
    color: #da3b30 !important;
    margin-bottom: 38px !important;
  }

  .message {
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 25px !important;
    line-height: 50px !important;
    display: flex !important;
    align-items: center !important;
    text-transform: capitalize !important;
    color: #000000 !important;
    margin-bottom: 24px !important;
  }
}

.right-side {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding-left: 65px !important;
  padding-right: 0 !important;
}

.btn {
  text-transform: capitalize;
  font-style: normal !important;
  font-size: 20px;
  line-height: 37px;
}
</style>

<style lang="scss" scoped>
@media (max-width: 1440px) {
  .footer-top {
    padding-top: calc(30px + (47 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
    padding-bottom: calc(30px + (54 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .form-container {
    padding-top: calc(30px + (150 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
    padding-bottom: calc(30px + (90 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .left-side {
    padding-right: calc(30px + (65 - 30) * ((100vw - 320px) / (1440 - 320))) !important;

    .title {
      font-size: calc(20px + (50 - 20) * ((100vw - 320px) / (1440 - 320))) !important;
      line-height: calc(30px + (75 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
      margin-bottom: calc(15px + (38 - 15) * ((100vw - 320px) / (1440 - 320))) !important;
    }

    .message {
      font-size: calc(16px + (25 - 16) * ((100vw - 320px) / (1440 - 320))) !important;
      line-height: calc(20px + (50 - 20) * ((100vw - 320px) / (1440 - 320))) !important;
      margin-bottom: calc(18px + (24 - 18) * ((100vw - 320px) / (1440 - 320))) !important;
    }
  }

  .right-side {
    padding-left: calc(30px + (65 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .btn {
    font-size: calc(14px + (20 - 14) * ((100vw - 320px) / (1440 - 320))) !important;
    line-height: 37px;
  }
}

@media (max-width: 599px) {
  .left-side {
    padding-right: 0 !important;
  }

  .right-side {
    padding-left: 0 !important;
  }
}
</style>


